import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FilterOptions } from '../../types';

interface FilterState {
  options: FilterOptions;
}

const initialState: FilterState = {
  options: {
    sort: '',
    category: '',
    search: '',
    priceRange: [0, 1000],
    merchant: '',
    location: '',
    date: '',
    status: ''
  },
};

export const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setFilterOptions: (state, action: PayloadAction<Partial<FilterOptions>>) => {
      state.options = { ...state.options, ...action.payload };
    },
    resetFilters: (state) => {
      state.options = initialState.options;
    },
  },
});

export const { setFilterOptions, resetFilters } = filterSlice.actions;
export default filterSlice.reducer;